import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context'
import { Skeleton } from '@mui/material';
import { handleImageEnc } from '../../helpers/webapi.helper';

interface ImageFileProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {

}

export default function ImageFile({ src, ...rest }: Readonly<ImageFileProps>) {
    const appContext = useContext(AppContext);
    const [localUrl, setLocalUrl] = useState('');

    useEffect(() => {
        if (!src) {
            return;
        }
        let token = appContext?.user.data?.token;
        handleImageEnc(src, setLocalUrl, token);
    }, [src]);

    return localUrl ? <img src={localUrl} {...rest} /> : <Skeleton
        style={rest.style}
        className={rest.className}
    />
}
